import React from 'react';
import PropTypes from 'prop-types';

import StyledLoadingIndicator from './loadingIndicator.style';

const LoadingIndicator = ({ className, inverted = false }) => (
  <StyledLoadingIndicator inverted={inverted} className={className}>
    <div className="loadingIndicator__spinner" />
  </StyledLoadingIndicator>
);

LoadingIndicator.propTypes = {
  className: PropTypes.string,
  inverted: PropTypes.bool
};

export default LoadingIndicator;
